"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightInner = exports.Right = exports.LoginFormContainer = exports.LeftInner = exports.Left = exports.Container = void 0;

var _reactPose = _interopRequireDefault(require("react-pose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var leftDuration = 1000;
var rightDelay = leftDuration + 250;
var rightDuration = 300;
var rightInnerDuration = 500;
var Base = (0, _styledComponents["default"])(_reactPose["default"].div())(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    overflow: hidden;\n    flex-direction: column;\n    width: 100%;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        flex-direction: row;\n        width: auto;\n    "]))));
var Container = (0, _reactPose["default"])(Base)({});
exports.Container = Container;
var Left = (0, _styledComponents["default"])(Base)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex: 1;\n    background-color: ", ";\n\n    min-height: 120px;\n\n    ", ";\n"])), function (props) {
  return props.theme.admin.colors.brandDark;
}, (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        min-height: 0;\n    "]))));
exports.Left = Left;
var LeftInner = (0, _reactPose["default"])((0, _styledComponents["default"])(Base)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    flex: 1;\n\n    .peracto-logo > svg {\n        width: 200px;\n\n        ", ";\n\n        ", ";\n    }\n"])), (0, _styledComponentsBreakpoint["default"])('tablet')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            width: 20rem;\n        "]))), (0, _styledComponentsBreakpoint["default"])('desktopL')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            width: 30rem;\n        "])))))({
  enter: {
    opacity: 1,
    transition: {
      duration: leftDuration
    }
  },
  exit: {
    opacity: 0
  }
});
exports.LeftInner = LeftInner;
var Right = (0, _reactPose["default"])((0, _styledComponents["default"])(Base)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    flex: 0 0 0px;\n"]))))({
  enter: {
    flexBasis: 600,
    delay: rightDelay,
    transition: {
      "default": {
        duration: rightDuration
      }
    }
  }
});
exports.Right = Right;
var RightInner = (0, _reactPose["default"])((0, _styledComponents["default"])(Base)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    flex: 1;\n    position: relative;\n"]))))({
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      "default": {
        duration: rightInnerDuration
      }
    }
  },
  exit: {
    opacity: 0,
    x: 300
  }
});
exports.RightInner = RightInner;

var LoginFormContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    background-color: #fff;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:before {\n        content: none;\n        position: absolute;\n        top: -1vh;\n        bottom: 0;\n        left: -75px;\n        width: 110px;\n        background-color: ", ";\n        transform: rotate(4deg);\n        height: 101vh;\n\n        ", ";\n    }\n\n    > div {\n        min-width: 270px;\n        max-width: calc(100% - 30px);\n\n        ", ";\n    }\n"])), function (props) {
  return props.theme.admin.colors.brandDark;
}, (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n            content: '';\n        "]))), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            min-width: 330px;\n            max-width: 480px;\n        "]))));

exports.LoginFormContainer = LoginFormContainer;